/* hs-eslint ignored failing-rules */

/* eslint-disable @typescript-eslint/no-floating-promises */

/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { FAILED, PENDING } from '../actions/constants/RequestStatus';
import { fetchFeatures } from '../actions/FeatureActions';
import { fetchCmsFeaturesStatus, fetchFeaturesStatus, fetchMarketingFeaturesStatus, fetchOperationsFeaturesStatus, fetchSalesFeaturesStatus, fetchServiceFeaturesStatus, hasFeaturesForProductLineAndHighlightsSelector } from '../selectors/FeatureSelectors';
export const useFeatureStore = ({
  highlightedProducts,
  productLine
}) => {
  const dispatch = useDispatch();
  const hasFeaturesForProductLine = useSelector(state => {
    return hasFeaturesForProductLineAndHighlightsSelector(state, {
      productLine,
      highlightedProducts
    });
  });
  const requestStatus = useSelector(fetchFeaturesStatus); // PER PRODUCT LINE REQUESTS

  const marketingRequestStatus = useSelector(fetchMarketingFeaturesStatus);
  const salesRequestStatus = useSelector(fetchSalesFeaturesStatus);
  const serviceRequestStatus = useSelector(fetchServiceFeaturesStatus);
  const operationsRequestStatus = useSelector(fetchOperationsFeaturesStatus);
  const cmsRequestStatus = useSelector(fetchCmsFeaturesStatus);

  const getRequestStatus = selectedProductLine => {
    let selectedStatus = requestStatus;

    switch (selectedProductLine) {
      case MARKETING:
        selectedStatus = marketingRequestStatus;
        break;

      case SALES:
        selectedStatus = salesRequestStatus;
        break;

      case SERVICE:
        selectedStatus = serviceRequestStatus;
        break;

      case OPERATIONS:
        selectedStatus = operationsRequestStatus;
        break;

      case CMS:
        selectedStatus = cmsRequestStatus;
        break;

      default:
        selectedStatus = requestStatus;
        break;
    }

    return selectedStatus;
  };

  useEffect(() => {
    if (!highlightedProducts.length || getRequestStatus(productLine) === PENDING || getRequestStatus(productLine) === FAILED || hasFeaturesForProductLine) {
      return;
    }

    if (!hasFeaturesForProductLine) {
      dispatch(fetchFeatures({
        highlightedProducts,
        productLine
      }));
    }
  }, [productLine, highlightedProducts]);
};